export default function Testimonials() {
  return null;
}
